export const myProjects = [
  {
    id: "1",
    nameProject: "Ta9adaw",
    projectTitle: "Ta9adaw - The Ultimate Online Marketplace",
    category: ["html", "css", "js"],
    imgPath: "./images/ecommeceHtmlCssJs.svg",
    video: "/video/ta9adaw.mp4",
    link: "#",
    desc: "A simple e-commerce website created using HTML, CSS, and JavaScript",
  },
  {
    id: "2",
    nameProject: "ReelCinema",
    projectTitle: "ReelCinema - The Ultimate Cinematic Experience",
    video: "/video/MovieProject.mp4",
    category: ["react", "css", "bootstrap"],
    imgPath: "./images/movies.svg",
    link: "#",
    desc: "This website utilizes the TMDb API to display a vast collection of movies, providing users with a comprehensive platform to explore and discover their cinematic interests.Built with ReactJS, the website leverages the power of this popular JavaScript library to create a dynamic and interactive user interface. Redux Toolkit, the official Redux state management library, ensures efficient and organized state management, while hooks provide a concise and elegant way to manage component state and side effects. The website's responsiveness ensures optimal viewing and navigation across all devices, from desktops to smartphones.",
  },
  {
    id: "3",
    nameProject: "طعم ونكهة ",
    projectTitle: "طعم ونكهة -Discover Culinary Pleasures",
    video: "/video/snackReact.mp4",
    category: ["react", "bootstrap"],
    imgPath: "./images/snackReactJs.svg",
    link: "#",
    desc: "This website leverages the power of ReactJS, a popular JavaScript library, to create a dynamic and user-friendly interface. Hooks, a modern feature of React, provide a concise and efficient way to manage component state and side effects.The website's clean and intuitive design makes it easy for users to navigate and discover new culinary delights. The search functionality allows users to quickly find specific dishes, while the category filters help narrow down choices based on mealtime or dietary preferences.",
  },
  // {
  //   id: "4",
  //   nameProject: "طعم ونكهة ",
  //   projectTitle: "طعم ونكهة -Discover Culinary Pleasures",
  //   // video: "/video/ta9adaw.mp4",

  //   category: ["react", "css"],
  //   imgPath: "./images/ecommerceReactJs1-1.svg",
  //   link: "#",
  //   desc: "Embark on unforgettable culinary experiences and indulge in the most delicious dishes",
  // },
  {
    id: "5",
    nameProject: "BestLabor",
    projectTitle: "BestLabor - Exceptional Construction Services",
    video: "/video/wordpressBestLab.mp4",

    category: ["wordpress"],
    imgPath: "./images/wordp1.svg",
    link: "#",
    desc: "This website utilizes the power of WordPress, a popular content management system, and the Divi theme, a versatile and customizable framework, to create a professional and engaging online presence for BestLabor.The website's design is tailored to effectively communicate BestLabor's value proposition and services to potential clients. It features clear and concise messaging, highlighting the company's expertise, experience, and commitment to delivering high-quality results.",
  },
  {
    id: "6",
    nameProject: "Muntajati",
    projectTitle: "Muntajati - Simplify Product Management",
    video: "/video/dashboardLaravel1.mp4",
    category: ["laravel"],
    imgPath: "./images/dashboardLaravel.svg",
    link: "#",
    desc: "This website utilizes the Laravel framework, a robust and popular PHP framework, to build a secure and efficient platform for managing various aspects of a business. The connection to a MySQL database through Laragon ensures data integrity and efficient data access.",
  },
  {
    id: "7",
    nameProject: "ShopEasyGo",
    projectTitle: "ShopEasyGo - Shop Anytime, Anywhere",
    video: "/video/StockFlutter.mp4",

    category: ["flutter"],
    imgPath: "./images/ecommerceFlutter.svg",

    link: "#",
    desc: "This application leverages the power of Flutter, a cross-platform mobile development framework, to create a visually appealing and responsive user interface. Firebase, a cloud-based platform, provides real-time data access and management for product information.",
  },
  {
    id: "8",
    nameProject: "ChatLinker",
    projectTitle: "ChatLinker - Connect and Chat Now",
    video: "/video/Chat_AppFlutter.mp4",

    category: ["flutter"],
    imgPath: "./images/chatFlutter.svg",

    link: "#",
    desc: "This application utilizes the power of Flutter, a cross-platform mobile development framework, to create a user-friendly and responsive chat interface. Firebase, a cloud-based platform, provides real-time data storage and retrieval for messages exchanged between users.",
  },
  {
    id: "9",
    nameProject: "Amar_Mogador",
    projectTitle: "Amar_Mogador - Discover Culinary Pleasures",
    video: "/video/wordpressMogador.mp4",

    category: ["wordpress"],
    imgPath: "./images/mogador.svg",

    link: "#",
    desc: "A website showcasing the delicious cuisine offered by Amar Mogador, enabling customers to discover and purchase their favorite dishes, built with WordPress, the Divi theme, and WooCommerce.This website leverages the power of WordPress, a popular content management system, the Divi theme's versatility and customization options, and the robust e-commerce capabilities of WooCommerce to create a user-friendly and visually appealing platform for Amar Mogador's online food ordering system.",
  },
  {
    id: "10",
    nameProject: "Valley_Ceram",
    projectTitle: "Valley_Ceram -Elegant Ceramic Creations",
    video: "/video/valleyWoordpre.mp4",
    category: ["wordpress"],
    imgPath: "./images/valleyceram.svg",
    link: "#",
    desc: "A website showcasing the products offered by Valley Ceram, enabling customers to discover and purchase their desired items, built with WordPress, the Divi theme, and WooCommerce.This website leverages the power of WordPress, a popular content management system, the Divi theme's versatility and customization options, and the robust e-commerce capabilities of WooCommerce to create a user-friendly and visually appealing platform for Valley Ceram's online store.",
  },
  {
    id: "11",
    nameProject: "Outfitly",
    projectTitle: "Outfitly - The Ultimate Online Marketplace",
    video: "/video/reactjsEcommerceFinal.mp4",

    category: ["react", "bootstrap"],
    imgPath: "./images/Ecommerce reactjs.svg",

    link: "#",
    desc: "An e-commerce website for purchasing products, built with ReactJS, Material UI, Bootstrap, Redux Toolkit, hooks, and MongoDB.This e-commerce website leverages the power of ReactJS, a popular JavaScript library for building user interfaces, Material UI and Bootstrap for user interface components and styling, Redux Toolkit for state management, hooks for functional components, and MongoDB for data storage.",
  },
  {
    id: "12",
    nameProject: "logos",
    projectTitle: "Creative Logo Design Services",
    video: "/video/logos.mp4",
    category: ["Figma"],
    imgPath: "./images/logos.svg",
    link: "#",
    desc: "Professional logo design with Adobe Illustrator and Figma.This project involves the creation of high-quality logos using industry-standard design software, Adobe Illustrator and Figma. The designer will leverage their expertise in these tools to create visually appealing, memorable, and brand-appropriate logos for clients.",
  },
  {
    id: "13",
    nameProject: "Posts/Story",
    projectTitle: "Dynamic Social Media Content Creation",
    video: "/video/story-post.mp4",
    category: ["Figma"],
    imgPath: "./images/STORY-POST.svg",
    link: "#",
    desc: "Professionally designed and engaging social media posts and stories for all platforms using Adobe Photoshop and Figma.",
  },
  {
    id: "14",
    nameProject: "business card",
    projectTitle: "Professional Business Card Creation Services",
    video: "/video/cardVisite.mp4",
    category: ["Figma"],
    imgPath: "./images/business card.svg",
    link: "#",
    desc: "Professionally designed and engaging business cards using Adobe Photoshop and Figma.",
  },
  {
    id: "15",
    nameProject: "Web Design 'E-commerce'",
    projectTitle: "Web Design for an E-commerce website.",
    video: "/video/figma web design.mp4",
    category: ["Figma"],
    imgPath: "./images/site web design.svg",
    link: "#",
    desc: "Professional web design and implementation of a design system, including colors, typography, grid, icons, and a library for use across all draft pages. Design components will be multi-component (dark and light modes, size, etc.).",
  },
  {
    id: "15",
    nameProject: "Web  Design 'My Portfolio'",
    projectTitle: "Web Design for 'My Portfolio'",
    video: "/video/figma web designPortfolio1.mp4",
    category: ["Figma"],
    imgPath: "./images/portfolioDesign.png",
    link: "#",
    desc: "Professional web design and implementation of a design system, encompassing colors, typography, grid, icons, and their integration into a library for utilization across all draft pages. Designing the components and making them multi-component (including dark and light modes, size variations, etc.). Additionally, I ensured the design is responsive. Lastly, I created a Figma prototype to demonstrate the visual appearance of the website (please refer to the video).",
  },
  {
    id: "16",
    nameProject: "Sihaty Mobile App:",
    projectTitle: "Sihaty Mobile App",
    // video: "/video/SITEWEBdESIGN.mp4",
    category: ["ionic","api"],
    imgPath: "./images/ionic.svg",
    link: "#",
    desc: "Mobile application for monitoring patient health and toxicity symptoms using Ionic Framework, Angular, TypeScript, Laravel API, and MySQL database.This project aims to develop a mobile application that helps healthcare professionals monitor patients' health and track potential toxicity symptoms. The application will leverage the power of Ionic Framework, Angular, TypeScript for the frontend development, and Laravel API with MySQL database for the backend.",
  },
  {
    id: "17",
    nameProject: "Portfolio",
    projectTitle: "Portfolio",
    // video: "/video/SITEWEBdESIGN.mp4",
    category: ["react", "bootstrap"],
    imgPath: "./images/portfolio.svg",
    link: "/",
    desc: "This application utilizes ReactJS, hooks, and React Bootstrap to create a visually appealing and informative portfolio website. The website is designed to effectively showcase my skills, experience, and projects to potential employers or clients.    ",
  },
  {
    id: "18",
    nameProject: "Restaurant",
    projectTitle: "Restaurant",
    video: "/video/NextjsRestau.mp4",
    category: ["nextJs", "bootstrap","api"],
    imgPath: "./images/restauranNextjs.svg",
    link: "/",
    desc: "This application utilizes Next.js for server-side rendering and static site generation, Redux Toolkit for state management, Bootstrap for responsive design, hooks for functional components, Laravel API for backend functionality, MySQL for data storage, and Laragon for local development. The goal of this application is to create a visually appealing and user-friendly website for a restaurant, allowing customers to browse the menu, view chef profiles, reserve tables, and manage their reservations",
  },
];
